module.exports = __webpack_public_path__ + "img/event.dcb96770.svg";